'use client';

import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui/components';
import { Link } from '@repo/features/adapters/next';
import { buildLoadsUrl } from './build-loads-url.ts';
export interface CompanyAnalyticsData {
  id: number;
  title: string;
}
export interface CompanyAnalyticsProps {
  analytics: {
    active_loads_count?: null | number;
    loads_count?: null | number;
  };
  company: CompanyAnalyticsData;
  label?: string;
  target?: '_blank' | '_self';
}
export const CompanyAnalyticsContent = t0 => {
  const $ = _c(19);
  const {
    analytics,
    company,
    label,
    target: t1
  } = t0;
  const target = t1 === undefined ? "_self" : t1;
  let t2;
  if ($[0] !== analytics || $[1] !== company) {
    t2 = analytics?.active_loads_count ? {
      href: buildLoadsUrl({
        columnId: "company_id",
        company,
        scope: "active"
      }),
      label: `${analytics.active_loads_count} active`,
      tooltip: "Go to active loads"
    } : null;
    $[0] = analytics;
    $[1] = company;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== analytics || $[4] !== company) {
    t3 = analytics?.loads_count ? {
      href: buildLoadsUrl({
        columnId: "company_id",
        company,
        scope: "completed"
      }),
      label: `${analytics.loads_count} completed`,
      tooltip: "Go to completed and archived loads"
    } : null;
    $[3] = analytics;
    $[4] = company;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = [t2, t3].filter(_temp);
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const links = t4;
  if (links.length === 0) {
    let t5;
    if ($[9] !== label) {
      t5 = label ? <>{label} -</> : <>0 completed loads</>;
      $[9] = label;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t5;
  if ($[11] !== label) {
    t5 = label ? <span>{label}</span> : null;
    $[11] = label;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== links || $[14] !== target) {
    t6 = links.map((link_0, index) => <span key={link_0.href}>{index > 0 ? ", " : null}<Tooltip><TooltipTrigger className="text-foreground" render={<Link href={link_0.href} target={target} />}>{link_0.label}</TooltipTrigger><TooltipContent side="right">{link_0.tooltip}</TooltipContent></Tooltip></span>);
    $[13] = links;
    $[14] = target;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
function _temp(link) {
  return link !== null;
}